export enum InvoiceStatus {
  PAID = 1,
  DECLINED = 2,
  CANCELLED = 3,
  NOT_PAID = 9,
}
